import { CLIENT_METHODS, RESOURCES, useApiMutation } from '@/data/api'

export const useLogin = (): ReturnType<typeof useApiMutation> => useApiMutation(RESOURCES.LOGIN, CLIENT_METHODS.POST)
